import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-navigation-arrow-right-icon',
  templateUrl: './navigation-arrow-right.component.html'
})
export class NavigationArrowRightComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
